import { Collection } from 'modules/core/lib/mobx-rest'

import FamilySituation from 'modules/employees/store/models/FamilySituation'

class FamilySituations extends Collection<FamilySituation> {
  get cacheKey(): string {
    return 'familySituations'
  }

  get indexes() {
    return ['employee_id']
  }

  model() {
    return FamilySituation
  }

  findByEmployeeId(employeeId: number) {
    const familySituation = this.find({
      employee_id: employeeId
    })

    if (familySituation) return familySituation

    return FamilySituation.getNull(+employeeId)
  }
}

export { FamilySituations }
